module.exports = __webpack_public_path__ + "ke.eb56b0fb47427f0fa8c1.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ke.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ke.svg
// module chunks = styles